import * as React from "react";

import Gallery from "../../types/Gallery";

import World from "../../world";
import GalleryDetail from "./View";

export interface Props {
    name: string;
    world: World;
}

export interface State {
    is_archiving: boolean;
    tourLive: boolean;
    tourGallery: boolean;
    tourQueue: boolean;
}

export default class GalleryDetailController extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            is_archiving: false,
            tourLive: false,
            tourGallery: false,
            tourQueue: false,
        };
    }
   
    componentDidMount() {
        this.tour();
    }

    tour() {
        if (!this.props.world.host.tour) {
            return;
        }

        if (!this.props.world.host.has_tacced) {
            this.setState({
                tourGallery: true,
            });
            return;
        }

        if (!this.props.world.host.has_experienced_live) {
            this.setState({
                tourLive: true,
            });
            return;
        }

        if (!this.props.world.host.has_managed_queue) {
            this.setState({
                tourQueue: true,
            });
            return;
        }
    }

    handleArchive = () => {
        this.props.world.archive(this.props.name)
            .then(([url, err]) => {
                this.setState({ is_archiving: false });
                if (err) {
                    // TODO
                    console.log(err);
                    return;
                }
                location.replace(url);
            });
        this.setState({ is_archiving: true });
    }

    render() {
        const gallery = this.props.world.galleries[this.props.name];

        if (!gallery) {
            // TODO spinner
            return null;
        }
        const shortURL = this.props.world.shortURL(gallery.access_token);
	const isSuperHost = gallery.hostID() === this.props.world.host.id();

        const props = {
            id: gallery.id(),
            host_id: gallery.hostID(),
            display_name: gallery.display_name,
            avatar: gallery.avatar,
            date: gallery.date,
            short_url: shortURL,
            live_url: shortURL + "?mode=live",
            upload_url: `${location.protocol}//${location.host}/up/${gallery.access_token}`,
            phone: gallery.prettyPhone(),
            onArchive: this.handleArchive,
            is_archiving: this.state.is_archiving,
            tourGallery: this.state.tourGallery,
            tourLive: this.state.tourLive,
            tourQueue: this.state.tourQueue,
	    is_super_host: isSuperHost,
        };

        return <GalleryDetail {...props} />
    }
}
